import React from "react"
import PropTypes from "prop-types"

import CloseIcon from "./assets/close.inline.svg"
import styles from "./map.module.scss"

const Marker = ({ id, content, selected, onSelect }) => {
  const isOpen = id === selected

  const handleClick = id => () => {
    onSelect(id)
  }

  return (
    <>
      <div
        onClick={handleClick(id)}
        className={`${styles.point} ${isOpen ? styles.selected : ""}`}
      />
      {isOpen && (
        <div className={styles.popup}>
          {content}

          <button
            className={styles.close}
            onClick={handleClick(null)}
            type="button"
          >
            <CloseIcon />
          </button>
        </div>
      )}
    </>
  )
}

Marker.propTypes = {
  content: PropTypes.node,
  selected: PropTypes.string,
  onSelect: PropTypes.func,
}

export default Marker
